var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isLoaded)?_c('prv-page-loader'):_c('router-view')}
var staticRenderFns = []

export { render, staticRenderFns }